import jwt_decode from "jwt-decode";

export function getCurrentUserRole() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (!auth?.access_token) return null;

    const decoded = jwt_decode(auth.access_token);
    return decoded?.permissions || null;
  } catch (error) {
    return null;
  }
}
